<template>
  <component
    :is="href ? 'a' : 'button'"
    v-bind="$attrs"
    :href="href || undefined"
    :type="href ? undefined : 'button'"
    class="dropdown-item"
    @click="onClick"
  ><slot></slot></component>
</template>
<script lang="ts">
import { defineComponent, inject } from 'vue'
import { dropdownContextKey } from './dropdown-context'
export default defineComponent({
  name: 'BDropdownItem',
  inheritAttrs: false,
  props: { href: { type: String, default: '' } },
  emits: ['click'],
  setup(_props, { emit }) {
    const dropdown = inject(dropdownContextKey, null)
    return {
      onClick(event: MouseEvent) {
        try {
          emit('click', event)
        } finally {
          dropdown?.close()
        }
      }
    }
  }
})
</script>
